module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel_02-503daf4009ab2005da1dee5322d6e7c8.jpg";